import { EbCompagnie } from "./compagnie";

export class EbLien {
    ebLienNum: number;
    url: string;    
    libelle: string;
    description: string;
    ebCompagnie: EbCompagnie;

    constructor(){
        this.ebLienNum = null;
        this.url = null;
        this.description = null;
        this.libelle = null;
        this.ebCompagnie = null;
      }

      constructorCopy(lien : EbLien ) {
            this.constructor();
          this.ebLienNum = null;
          this.description = lien.description;
          this.url = lien.url;
          this.libelle = lien.libelle;
          this.ebCompagnie = lien.ebCompagnie;
      }
    
      
}


// WEBPACK FOOTER //
// ./src/app/classes/lien.ts